module.exports = __webpack_public_path__ + "static/media/Image-Not-Available.442cf356.png";